import React from "react";
import './FAQ.css';
import FAQElements from "./FAQElements/FAQElements";
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";
import {GET_ALL_FAQ_CATEGORIES, GET_ALL_FAQ_ELEMENTS} from "../../../../AdminPart/GraphQL/queries/workWithInformation";

function TradingFAQSource (props) {
        const AllMenu = ['','ElementMenuActive','','','',''];
        let Active = 1;
        if (props.FilterFaq === 'partner') {
            AllMenu[1] = '';
            AllMenu[3] = 'ElementMenuActive';
            Active = 3;
        } else if (props.FilterFaq === 'tis') {
            AllMenu[1] = '';
            AllMenu[2] = 'ElementMenuActive';
            Active = 2;
        }
        return (
            <LayoutMain title={props.title} description={props.description} lang={props.lang}  AllMenu={AllMenu} Active={Active}>
                <FAQElements AllFAQCategories={props.PrerenderFAQ} AllFAQElements={props.PrerenderFAQBase} lang={props.lang} data={props.data} PrerenderTexts={props.PrerenderTexts}/>
            </LayoutMain>
        )}

export default TradingFAQSource